module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "modal-success"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Witamy w Programie Partnerskim Punkta")])]), _vm._v(" "), _c('template', {
    slot: "modal-body"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/success-icon.jpg")
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Jakie są następne kroki?")]), _vm._v(" "), _c('p', [_vm._v("Przejdź do swojego konta, skopiuj indywidualny link partnerski i zacznij promować ubezpieczenia Punkta.")])]), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Przejdź do panelu\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6386628","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalSuccessAccountDetails.vue
// module id = 403
// module chunks = 0